import type { Handler, Tracker } from './types';
import { clientOnly, getAnalyticsErrorType, instrumentHandler, instrumentTracker } from './utils';
import { logError } from '@zg-rentals/log-error';

export function defineTracker<Payload extends Record<string, unknown> = Record<string, unknown>>(
  handler: Handler<Payload>,
): Tracker<Payload> {
  return {
    __payload: null,
    handler,
    track: clientOnly((name: string, payload: Payload) => {
      try {
        handler(payload, instrumentHandler(name));
        instrumentTracker(name, payload);
      } catch (error) {
        logError({
          error,
          errorType: getAnalyticsErrorType(`Tracker_${name}`),
          context: { name, payload },
        });
      }
    }),
  };
}
